import React, { useEffect, useState } from "react";
import { userProfile } from "../api/Api";
import { userId, userToken } from "../../Utils/userAuth";
import "./WtPrev7.css";

const WtPrev7 = (props) => {
    const currentUrl = window.location.hostname;
    const url = window.location.host
    const [inputVal, setInputVal] = useState("")
    const [bubbleText, setBubbleText] = useState("Need help?");
    const [bubbleVisible, setBubbleVisible] = useState(true);
    // console.log(url)
    // console.log(currentUrl)
    // const cleanUrl = currentUrl.replace(/^http:\/\//, "");
    // console.log(cleanUrl);
    const [parent_id, setParent_id] = useState(null);
    const [parentType, setParentType] = useState(null);
    const [brandName, setBrandName] = useState("");

    useEffect(() => {
        const siteSettings = localStorage.getItem("siteSettings");
        if (siteSettings) {
            const parsed = JSON.parse(siteSettings);
            setBrandName(parsed.brand_name || "");
        }
    }, []);

    useEffect(() => {
        const storedLogin = localStorage.getItem("login");
        if (storedLogin) {
            const parsed = JSON.parse(storedLogin);
            setParentType(parsed?.user?.parent_type || null);
        }
        let paramData = {
            user_id: userId,
            token: userToken,
            method: "retrieve"
        }

        userProfile(paramData).then((result) => {
            if (result.data.success === true) {
                setParent_id(result.data.data[0].parent);
            }
        })
    }, []);



    useEffect(() => {
        const texts = ["Need help?", "Chat with us!", "Start chat!", "Quick support?", "We're Online"];
        let index = 0;
        const interval = setInterval(() => {
            setBubbleVisible(false);
            setTimeout(() => {
                index = (index + 1) % texts.length;
                setBubbleText(texts[index]);
                setBubbleVisible(true);
            }, 300);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    function ft() {
        const now = new Date();
        let hrs = now.getHours();
        const mnt = now.getMinutes();
        const ampm = hrs >= 12 ? "PM" : "AM";
        hrs = hrs % 12;
        hrs = hrs ? hrs : 12;
        const mf = mnt.toString().padStart(2, "0");
        const tf = `${hrs}:${mf} ${ampm}`;
        return tf;
    }
    const wpBtn = () => {
        const td = document.getElementById("authkey-tgl");
        if (td.classList.contains("authkey-ds7")) {
            td.classList.remove("authkey-ds7");
            td.classList.add("authkey-dh7");
        } else {
            td.classList.remove("authkey-dh7");
            td.classList.add("authkey-ds7");
        }
    };
    const cbtn = () => {
        const td = document.getElementById("authkey-tgl");
        if (td.classList.contains("authkey-ds7")) {
            td.classList.remove("authkey-ds7");
            td.classList.add("authkey-dh7");
        }
    };

    const wpcBtn = () => {
        const urlencodedtext = encodeURIComponent(inputVal);
        const url = `https://wa.me/${props.mobile_no}?text=${urlencodedtext}`;

        window.open(url, "_blank");
    };

    return (
        <div style={{ position: "relative", overflow: "hidden" }}>
            <div
                className="authkey-m-d7"
                style={{
                    [props.position]: `${props.sidemargin}px`,
                    bottom: `${props.marginbottom}px`,
                }}
            >
                <div
                    id="authkey-tgl"
                    className={`authkey-whatsappWindow7 ${props.wtstatus === "yes" ? "authkey-ds7" : "authkey-dh7"
                        }`}
                >
                    <div className="authkey-whatsappWindowShadow7">
                        <div
                            role="button"
                            id="authkey-cbtn7"
                            tabIndex="0"
                            className="authkey-whatsappCloseIcon7"
                            onClick={cbtn}
                        ></div>
                        <div
                            className="authkey-whatsappHeader7"
                           style={{ background: `${props.bgcolor}` }}
                        >
                            <div className="authkey-whatsappAvataarContainer7">
                                <div className="authkey-whatsappAvataar7">
                                    <img
                                        src={props.logourl}
                                        alt="user_image"
                                        className="authkey-whatsappAvataarImg7"
                                    />
                                </div>
                            </div>
                            <div className="authkey-whatsappHeaderInfo7">
                                <div className="authkey-whatsappAvataarName7">
                                    {props.displayname}
                                </div>
                                <div className="authkey-whatsappOnline7">Online</div>
                            </div>
                        </div>
                        <div className="authkey-whatsappBottomLayout7">
                            <div className="authkey-whatsappChatbox7">
                                <div className="authkey-whatsappChatLayout7">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="9"
                                        height="17"
                                        viewBox="0 0 9 17"
                                        fill="currentColor"
                                        className="authkey-whatsappChatSvg7"
                                    >
                                        <path
                                            d="M0.772965 3.01404C-0.0113096 1.68077 0.950002 0 2.49683 0H9V17L0.772965 3.01404Z"
                                            fill="currentColor"
                                        ></path>
                                    </svg>
                                    <div className="authkey-whatsappChatMessage7">
                                        <div>{props.wltxt}</div>
                                    </div>
                                    <div className="authkey-whatsappChatTime7">{ft()}</div>
                                </div>
                                {/* <div className="authkey-whatsappBottomnext">
                  <button
                    title="WhatsApp"
                    id="authkey-wp-r-b"
                    className="authkey-whatsappBtnInline"
                    type="button"
                    tabIndex="0"
                    onClick={wpcBtn}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="9"
                      height="17"
                      viewBox="0 0 9 17"
                      fill="currentColor"
                      className="authkey-whatsappChatSvg"
                    >
                      <path
                        d="M0.772965 3.01404C-0.0113096 1.68077 0.950002 0 2.49683 0H9V17L0.772965 3.01404Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                    Chat on WhatsApp<span></span>
                  </button>
                </div> */}
                                <div class="authkey-message-container7">

                                    <input id="authkey7-message-input7" placeholder="Type your text here..." value={inputVal} onChange={(e) => setInputVal(e.target.value)} />


                                    <button
                                        class="authkey7-send-button7"
                                        id="authkey-wp-r-b"
                                        onClick={wpcBtn}>
                                        <span>➤</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        {!props.removeBranding && (
                        <div className="authkey-branding7">

                            {(parentType !== "reseller" || parent_id === 10774 || parent_id === 5643 || (brandName && brandName.trim() !== "")) && (
                                <img
                                    draggable="false"
                                    alt="âš¡"
                                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAzNiI+PHBhdGggZmlsbD0iI0ZGQUMzMyIgZD0iTTMyLjkzOCAxNS42NTFDMzIuNzkyIDE1LjI2IDMyLjQxOCAxNSAzMiAxNUgxOS45MjVMMjYuODkgMS40NThjLjIxOS0uNDI2LjEwNi0uOTQ3LS4yNzEtMS4yNDNDMjYuNDM3LjA3MSAyNi4yMTggMCAyNiAwYy0uMjMzIDAtLjQ2Ni4wODItLjY1My4yNDNMMTggNi41ODggMy4zNDcgMTkuMjQzYy0uMzE2LjI3My0uNDMuNzE0LS4yODQgMS4xMDVTMy41ODIgMjEgNCAyMWgxMi4wNzVMOS4xMSAzNC41NDJjLS4yMTkuNDI2LS4xMDYuOTQ3LjI3MSAxLjI0My4xODIuMTQ0LjQwMS4yMTUuNjE5LjIxNS4yMzMgMCAuNDY2LS4wODIuNjUzLS4yNDNMMTggMjkuNDEybDE0LjY1My0xMi42NTVjLjMxNy0uMjczLjQzLS43MTQuMjg1LTEuMTA2eiIvPjwvc3ZnPg=="

                                />
                            )}

                            {parentType === "reseller" ? (
                                parent_id === 10774 ? (
                                    <p>by <span style={{ fontSize: "10px" }}>adznetworkmedia.om</span></p>
                                ) : parent_id === 5643 ? (
                                    <p>
                                        by <span style={{ fontSize: "10px" }}>cpaasnettyfish.com</span>
                                    </p>
                                ) : brandName && brandName.trim() !== "" ? (
                                    <p>by <span>{brandName}</span></p>
                                ) : null
                            ) : (
                                <p>by&nbsp;
                                    <a href="https://authkey.io" target="_blank" rel="noreferrer">
                                        <span>Authkey.io</span>
                                    </a>
                                </p>
                            )}
                        </div>
                        )}
                        {/* <div className="authkey-branding">
              <img
                draggable="false"
                alt="âš¡"
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAzNiI+PHBhdGggZmlsbD0iI0ZGQUMzMyIgZD0iTTMyLjkzOCAxNS42NTFDMzIuNzkyIDE1LjI2IDMyLjQxOCAxNSAzMiAxNUgxOS45MjVMMjYuODkgMS40NThjLjIxOS0uNDI2LjEwNi0uOTQ3LS4yNzEtMS4yNDNDMjYuNDM3LjA3MSAyNi4yMTggMCAyNiAwYy0uMjMzIDAtLjQ2Ni4wODItLjY1My4yNDNMMTggNi41ODggMy4zNDcgMTkuMjQzYy0uMzE2LjI3My0uNDMuNzE0LS4yODQgMS4xMDVTMy41ODIgMjEgNCAyMWgxMi4wNzVMOS4xMSAzNC41NDJjLS4yMTkuNDI2LS4xMDYuOTQ3LjI3MSAxLjI0My4xODIuMTQ0LjQwMS4yMTUuNjE5LjIxNS4yMzMgMCAuNDY2LS4wODIuNjUzLS4yNDNMMTggMjkuNDEybDE0LjY1My0xMi42NTVjLjMxNy0uMjczLjQzLS43MTQuMjg1LTEuMTA2eiIvPjwvc3ZnPg=="

              />
              <p>by   </p>
              {parent_id !== 10774 && (
                <a href="https://authkey.io" target="_blank">
                  {" "}
                  <span>Authkey.io</span>
                </a>
              )}
              {parent_id === 10774 && (
                <span style={{ fontSize: "10px" }}>adznetworkmedia.om</span>
              )}
            </div> */}
                    </div>
                </div>

                <div style={{ position: "relative", display: "inline-block", float: `${props.position}` }}>
                    <div
                        className="authkey-rotating-bubble7"
                        style={{ opacity: bubbleVisible ? 1 : 0 }}
                    >
                        <span className="authkey-rotating-word7">{bubbleText}</span>
                    </div>
                    <button
                        className="authkey7-whatsappBtn7"
                        id="authkey-wt-btn"
                        onClick={wpBtn}
                    >
                        <img
                            src={props.logourl}
                            alt="user_image"
                            className=" authkey7-whatsappIcon7"
                        />
                        <span className="authkey7-whatsappLive7"></span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WtPrev7;
